import {
    NoteIcon,
    PersonIcon,
    PencilIcon,
    SyncIcon,
    TrashIcon,
    UndoIcon
} from "@primer/octicons-react";
import { Box, Checkbox } from '@primer/react';

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Transition } from 'semantic-ui-react';
import { hachToanCongNoApi } from "../../../../api/hachToanCongNopApi";
import { hocSinhApi } from "../../../../api/hocSinhApi";
import { AnimationConfirm } from '../../../../components/confirm';
import Button from '../../../../components/ui/button';
import DataGrid from "../../../../components/data-grid";
import { IDataGridColumn } from "../../../../components/data-grid/type/IDataGridProps";
import { useCommonContext } from '../../../../contexts/common';
import { PageBaseStatus } from '../../../../models/pageBaseStatus';
import { sf_hachtoan_congno, sf_hachtoan_congno_viewmodel } from "../../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import { ts_hocsinh_viewmodel } from "../../../../models/response/hocsinh/ts_hocsinh";
import {
    changeHachToanCongNoSelectionIds, closeHachToanCongNoDeleteConfirm, closeHachToanCongNoDetailModal, closeHachToanCongNoRefundConfirm, deleteHachToanCongNoStart,
    refundHachToanCongNoStart, saveHachToanCongNoStart,
    showHachToanCongNoDeleteConfirm, showHachToanCongNoDetailModal,
    showHachToanCongNoRefundConfirm
} from '../../../../state/actions/hachToanCongNoActions';
import { RootState } from '../../../../state/reducers';
import { DetailQuyetToanModal } from "./DetailQuyetToanModal";
import Text from "../../../../components/ui/text";
import { HocSinhRender, Infomation } from "../../../../components/hoc-sinh/HocSinhRender";
type QuyetToanHocSinhProps = {
    ts_hocsinh_id: number,
}
const QuyetToanHocSinh = (props: QuyetToanHocSinhProps) => {
    const { translate } = useCommonContext();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [danhSachQuyetToanSelectedIds, setDanhSachQuyetToanSelectedIds] = useState<number[]>([]);

    const state = useSelector((x: RootState) => x.hachToan)
    const { nam_hoc } = useSelector((x: RootState) => x.common);
    const [hoanPhiTypeId, setHoanPhiTypeId] = useState<number>(-1);
    const [sf_hachtoan_congno_viewmodel, set_sf_hachtoan_congno_viewmodel] = useState<sf_hachtoan_congno_viewmodel[]>([])
    const [ts_hocsinh_viewmodel, set_ts_hocsinh_viewmodel] = useState<ts_hocsinh_viewmodel>()
    const { status,
        //filter,
        sf_hachtoan_congno_selected_ids,
        sf_hachtoan_congno_editing,
        is_show_detail_modal,
        is_show_delete_confirm,
        is_show_import_modal,
        is_show_refund_confirm

    } = state;

    const dataSource = useMemo(() => {
        return sf_hachtoan_congno_viewmodel.filter(x => hoanPhiTypeId === -1 || hoanPhiTypeId === x.sf_hoanphi_type_id);
    }, [hoanPhiTypeId, sf_hachtoan_congno_viewmodel])
    const handleReload = async () => {
        setIsLoading(true)
        const res = await hachToanCongNoApi.select_all_by_hocsinh({ ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: nam_hoc })
        if (res.is_success) {
            set_sf_hachtoan_congno_viewmodel(res.data)
        }
        setIsLoading(false)
    }
    const handleReloadHocSinh = async () => {
        setIsLoading(true)
        const res = await hocSinhApi.selectByIdNamHoc({ ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: nam_hoc })
        if (res.is_success) {
            set_ts_hocsinh_viewmodel(res.data)
        }
        setIsLoading(false)
    }
    useEffect(() => {
        if (status && status === PageBaseStatus.is_need_reload)
            handleReload();
    }, [status])
    useEffect(() => {
        handleReload();
        handleReloadHocSinh();
    }, [])

    const handleRefresh = () => {
        handleReload();
        handleReloadHocSinh();
        onSelectionChanged([])
        setDanhSachQuyetToanSelectedIds([])
    }

    const handleCloseDeleteConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoDeleteConfirm())
    }, [])
    const handleCloseRefundConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoRefundConfirm())
    }, [])
    const handleShowDeleteConfirm = useCallback(() => {
        dispatch(showHachToanCongNoDeleteConfirm())
    }, [])
    const handleShowRefundConfirm = useCallback(() => {
        dispatch(showHachToanCongNoRefundConfirm())
    }, [])
    const handleConfirmRefund = useCallback(() => {
        dispatch(refundHachToanCongNoStart(sf_hachtoan_congno_selected_ids))
    }, [sf_hachtoan_congno_selected_ids]);

    const handleBtnEditClicked = useCallback((data: sf_hachtoan_congno_viewmodel) => {
        dispatch(showHachToanCongNoDetailModal(data));
    }, [dispatch])
    const onSelectionChanged = useCallback((selectedRowKeys: number[]) => {
        dispatch(changeHachToanCongNoSelectionIds(selectedRowKeys))
    }, [])
    const handleConfirmDelete = useCallback(() => {
        dispatch(deleteHachToanCongNoStart(sf_hachtoan_congno_selected_ids))
    }, [sf_hachtoan_congno_selected_ids]);

    const handleCloseDetailModal = useCallback(() => {
        dispatch(closeHachToanCongNoDetailModal())
    }, [])
    const handleSubmitDetailModal = useCallback((data: sf_hachtoan_congno) => {
        dispatch(saveHachToanCongNoStart(data))
    }, [])

    const columns = useMemo<IDataGridColumn[]>(() => {
        return [
            {
                id: "edit",
                caption: "#",
                width: 50,
                align: "center",
                fixed: "left",
                cellRender: (data: any) => {
                    if (data?.is_da_thanh_toan) {
                        return <></>;
                    }
                    return (
                        <Box
                            id={`btnEdit${data.id}`}
                            as="button"
                            sx={{
                                cursor: "pointer",
                                color: "#3c22ff",
                                background: "none",
                                border: "none",
                                padding: 0,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onClick={() => handleBtnEditClicked(data)}
                        >
                            <PencilIcon size={16} />
                        </Box>
                    );
                },
            },
            {
                id: "ho_ten",
                dataField: "ho_ten",
                caption: translate("Học sinh"),
                width: 200,
                fixed: "left",
                isMainColumn: true,
                cellRender: (data: any) => {
                    const infos: Infomation[] = [
                        { title: '', data: data.ho_ten, icon: <PersonIcon size={14} />, fontWeight: "500" },
                        { title: '', data: data.ma_hs, icon: <NoteIcon size={14} /> },
                    ];
                    return (
                        <HocSinhRender infors={infos} />
                    )
                },
            },
            {
                id: "ten_khoi",
                caption: translate("Tên khối"),
                dataField: "ten_khoi",
                width: 150,
            },
            {
                id: "ten_lop",
                caption: translate("Tên lớp"),
                dataField: "ten_lop",
                width: 100,
            },
            {
                id: "noi_dung",
                caption: translate("Nội dung"),
                dataField: "noi_dung",
            },
            {
                id: "tong_tien",
                caption: translate("Tổng tiền"),
                dataField: "tong_tien",
                width: 120,
                align: "right",
                cellRender: (data: any) => (
                    <Box sx={{ whiteSpace: "pre-line", textAlign: 'right' }}>{data.tong_tien.toLocaleString()}</Box>
                ),
            },
            {
                id: "is_hoan_tra",
                caption: translate("Loại"),
                width: 100,
                cellRender: (data: any) => (
                    <Box>{data?.is_hoan_tra ? "Hoàn trả" : "Thu bổ sung"}</Box>
                ),
            },
            {
                id: "is_da_thanh_toan",
                caption: translate("Đã thanh toán"),
                dataField: "is_da_thanh_toan",
                width: 100,
                align: "center",
                cellRender: (data: any) => (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Checkbox
                            checked={data.is_da_thanh_toan === true}
                            aria-label="Kích hoạt"
                        />
                    </Box>
                ),
            },
            {
                id: "is_hoantra_phuhuynh",
                caption: translate("Hoàn trả PH"),
                dataField: "is_hoantra_phuhuynh",
                width: 100,
                align: "center",
                cellRender: (data: any) => (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Checkbox
                            checked={data.is_hoantra_phuhuynh === true}
                            aria-label="Hoàn trả PH"
                        />
                    </Box>
                ),
            },
        ];
    }, [handleBtnEditClicked, translate]);

    return (
        <React.Fragment>
            <Box sx={{ p: 1 }}>
                <Transition animation="scale"
                    visible={true}
                    duration={100}
                    transitionOnMount={true}>
                    <Box>
                        <Box sx={{ m: 1 }}>
                            <DataGrid
                                title={<Text text={translate("Danh sách quyết toán")} sx={{ fontSize: 16, fontWeight: 600 }} />}
                                dataSource={dataSource}
                                keyExpr="id"
                                height={window.innerHeight - 300}
                                isLoading={isLoading || state.status === PageBaseStatus.is_loading}
                                selection={{
                                    mode: "multiple",
                                    selectedRowKeys: danhSachQuyetToanSelectedIds,
                                    onSelectionChanged: (keys: number[]) => {
                                        setDanhSachQuyetToanSelectedIds(keys);
                                        onSelectionChanged(keys);
                                    },
                                }}
                                searchEnable={true}
                                filterRow={{
                                    enable: true
                                }}
                                actionComponent={
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2
                                    }}>
                                        <Button
                                            text={translate("Làm mới")}
                                            leadingVisual={SyncIcon}
                                            variant="default"
                                            size="small"
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                            onClick={handleRefresh}
                                        />
                                        <Button
                                            disabled={danhSachQuyetToanSelectedIds.length === 0}
                                            text={translate("Hoàn trả Phụ huynh")}
                                            leadingVisual={UndoIcon}
                                            variant="primary"
                                            size="small"
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                            onClick={handleShowRefundConfirm}
                                        />
                                        <Button
                                            disabled={danhSachQuyetToanSelectedIds.length === 0}
                                            text={translate("Xóa quyết toán")}
                                            leadingVisual={TrashIcon}
                                            variant="danger"
                                            size="small"
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                            onClick={handleShowDeleteConfirm}
                                        />
                                    </Box>
                                }
                                columns={columns}
                                paging={{
                                    enable: true,
                                    pageSize: 50,
                                    pageSizeItems: [50, 100, 200, 500]
                                }}
                                exportConfig={{
                                    enable: true,
                                    fileName: "danh-sach-quyet-toan"
                                }}
                            />
                            {is_show_detail_modal && <DetailQuyetToanModal
                                sf_hachtoan_congno={sf_hachtoan_congno_editing}
                                onClose={handleCloseDetailModal}
                                onSubmit={handleSubmitDetailModal}
                                is_saving={status === PageBaseStatus.is_saving}
                                nam_hoc={nam_hoc}
                                title={`${sf_hachtoan_congno_editing ? "Sửa " : "Thêm mới "} quyết toán`}
                                animationOf={sf_hachtoan_congno_editing ? `#btnEdit${sf_hachtoan_congno_editing.id}` : "#btnInsert"}
                                dm_truong_id={ts_hocsinh_viewmodel?.dm_truong_id}
                                ts_hocsinh={ts_hocsinh_viewmodel}

                            />
                            }
                        </Box>

                    </Box>
                </Transition>
                {is_show_delete_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseDeleteConfirm}
                        onConfirmed={handleConfirmDelete}
                        text={`Bạn có chắc chắn muốn xóa ${danhSachQuyetToanSelectedIds.length} khoản hạch toán đã chọn ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không xóa"
                        text_confirm_button="Tiếp tục xóa"
                        type='danger'
                        animationOf='#btnDelete'

                    />
                }
                {is_show_refund_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseRefundConfirm}
                        onConfirmed={handleConfirmRefund}
                        text={`Bạn có chắc chắn muốn cập nhật ${danhSachQuyetToanSelectedIds.length} khoản hạch toán đã chọn thành Hoàn trả PH ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không"
                        text_confirm_button="Tiếp tục"
                        type='success'
                        animationOf='#btnRefund'

                    />
                }
            </Box>
        </React.Fragment >
    );
}
export default QuyetToanHocSinh;